var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value && _vm.value.code)?_c('v-chip',{staticClass:"px-1",attrs:{"small":"","outlined":""}},_vm._l((_vm.count),function(index){return _c('v-icon',{key:index,attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }